import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { Component } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { MultiSubscriptionComponent } from '@ddv/common-components';
import { URLCellRendererParams } from '@ddv/data-grid';
import { AUTO_GROUP_COLUMN_ID } from '@ddv/models';
import { linkify } from '@ddv/utils';
import { Theme, ThemeService } from '@hs/ui-core-presentation';

/*
    This renderer does not render URLs at all.
    It renders simple spans with a class on them that mimics a hyperlink
    BaseGridVisualizationComponent picks up on the cell click and goes from there
 */
@Component({
    selector: 'app-url-cell-renderer',
    templateUrl: './url-cell-renderer.component.html',
    styleUrls: ['./url-cell-renderer.component.scss'],
    standalone: false,
})
export class URLCellRendererComponent extends MultiSubscriptionComponent implements ICellRendererAngularComp {
    cellInnerHTML: SafeHtml | undefined;
    private params: URLCellRendererParams | undefined;
    private theme: Theme = Theme.light;

    constructor(private readonly sanitizer: DomSanitizer, private readonly themeService: ThemeService) {
        super();
    }

    agInit(params: URLCellRendererParams): void {
        this.params = params;

        this.subscribeTo(this.themeService.currentTheme$, (theme: Theme) => {
            this.theme = theme;
            this.setup();
        });
    }

    refresh(): boolean {
        this.setup();
        return true;
    }

    private setup(): void {
        if (!this.params) {
            return;
        }

        const valueToSanitize = this.params.colDef?.colId === AUTO_GROUP_COLUMN_ID ?
            this.params.value :
            this.params.valueFormatted;

        if (valueToSanitize && isNaN(valueToSanitize) && !valueToSanitize.toString().includes('external-app-link')) {
            this.cellInnerHTML = this.sanitizer.bypassSecurityTrustHtml(linkify(valueToSanitize, '_self'));
        } else {
            this.cellInnerHTML = this.sanitizer.bypassSecurityTrustHtml(valueToSanitize);
        }
    }
}
